exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table[data-v-0c545fd2]{\n    width: 100%;\n    table-layout: fixed;\n}\n.table th[data-v-0c545fd2] {\n    border: 0 dotted #000000;\n    border-bottom-width: 1px;\n    padding: 5px;\n}\n.table td[data-v-0c545fd2] {\n\n    text-align: center;\n    padding: 5px;\n}\n.table td[data-v-0c545fd2]:first-child, .table th[data-v-0c545fd2]:first-child {\n    text-align: left;\n}\n.up[data-v-0c545fd2], .down[data-v-0c545fd2]{\n    font-size: 4em;\n}\n.up[data-v-0c545fd2]{\n    rotate: 50deg;\n}\n.down[data-v-0c545fd2]{\n    rotate: 300deg;\n}\n", ""]);

// exports
